const ASSET = "https://customer-assets-lqy194kg.emergentagent.net/job_e99b9217-c874-44ff-a502-23e6509fa304/artifacts";
const ASSET2 = "https://customer-assets-wrfwihn1.emergentagent.net/job_fragrant-zahra/artifacts";

export const IMAGES = {
    heroArt: `${ASSET}/x5xmy5p7_ChatGPT%20Image%20Aug%2011%2C%202026%20at%2008_36_30%20PM.png`,
    frenchIceBox: `${ASSET2}/h7v7k74m_A7C96CEF-6A8D-4433-BB24-938A7045A0B6.PNG`,
    burberyBox: `${ASSET}/2kg5gnwc_ChatGPT%20Image%20Aug%2011%2C%202026%20at%2008_58_21%20PM.png`,
    logo: `${ASSET}/5prel5lj_713929fc-b42a-413b-a6cb-a483eed71c20.JPG`,
    vampireBloodBox: `${ASSET2}/bqcmyhyf_9B4A27B0-14E8-4F83-9AA1-50EE7751889E.PNG`,
    pinkOudMirageBox: `${ASSET2}/1k1rwekc_8B128181-1D4D-4707-A9CE-E3F18051DFE2.PNG`,
    calmSeaBox: `${ASSET2}/hnnv1n2x_FA39A0CB-C5A4-4908-B828-7F32443C4AA3.PNG`,
    arabianScenery: `${ASSET2}/ztzdobpy_ChatGPT%20Image%20Aug%2024%2C%202026%20at%2002_31_00%20PM.png`,
    pinkChiffonPoster: `${ASSET2}/43goks11_IMG_6250.PNG`,
    alZahraBag: `${ASSET2}/j5o7iw9h_ChatGPT%20Image%20Aug%2022%2C%202026%20at%2002_13_42%20AM.png`,
};

export const PRODUCTS = [
    {
        id: "french-ice",
        name: "French Ice",
        tag: "The French Series · Attar · 12 ml",
        price: 299,
        image: IMAGES.frenchIceBox,
        gallery: [IMAGES.frenchIceBox, IMAGES.alZahraBag],
        description:
            "A fresh, refined and sophisticated scent that captures the cool elegance of nature. Crisp citrus over a heart of blossom and spice, resting on warm woods and musk.",
        notes: {
            top: ["Apple", "Italian Lemon", "Sicilian Bergamot"],
            heart: ["Plum", "Orange Blossom", "Cardamom"],
            base: ["Musk", "Amber", "Driftwood", "Moss"],
        },
    },
    {
        id: "burbery-for-her",
        name: "Pink Chiffon",
        tag: "The French Series · Attar · 12 ml",
        price: 299,
        image: IMAGES.pinkChiffonPoster,
        gallery: [IMAGES.pinkChiffonPoster, IMAGES.alZahraBag],
        description:
            "A delicate and graceful attar that celebrates femininity. Soft florals, gentle fruits and warm musks come together to create a scent that is timeless, romantic and unforgettable.",
        notes: {
            top: ["Gentle Fruits", "Pink Petals"],
            heart: ["Soft Florals", "Orange Blossom", "Rose"],
            base: ["Warm Musks", "Amber", "Vanilla Woods"],
        },
    },
    {
        id: "vampire-blood",
        name: "Cold Blood",
        tag: "The French Series · Attar · 12 ml",
        price: 299,
        accent: "#6E1423",
        image: IMAGES.vampireBloodBox,
        gallery: [IMAGES.vampireBloodBox, IMAGES.alZahraBag],
        description:
            "A fruity elixir that awakens the senses with a fresh sour spark, soft white flowers, and the deep sweetness of plum. Bold, mysterious, and irresistibly captivating.",
        notes: {
            top: ["Fresh Sour Spark", "Red Fruits"],
            heart: ["Soft White Flowers", "Night Jasmine"],
            base: ["Deep Plum", "Dark Musk", "Velvet Amber"],
        },
    },
    {
        id: "pink-oud-mirage",
        name: "Pink Oud Mirage",
        tag: "The French Series · Attar · 12 ml",
        price: 299,
        accent: "#A94F66",
        image: IMAGES.pinkOudMirageBox,
        gallery: [IMAGES.pinkOudMirageBox, IMAGES.alZahraBag],
        description:
            "A dreamy mirage of elegance and allure. Pink Oud Mirage opens with soft, fruity florals and melts into a heart of delicate rose and warm oud. The base lingers with creamy woods, amber, and musk — captivating, mysterious, unforgettable.",
        notes: {
            top: ["Soft Fruity Florals"],
            heart: ["Delicate Rose", "Warm Oud"],
            base: ["Creamy Woods", "Amber", "Musk"],
        },
    },
    {
        id: "calm-sea",
        name: "Calm Sea",
        tag: "The French Series · Attar · 12 ml",
        price: 299,
        accent: "#5F7267",
        image: IMAGES.calmSeaBox,
        gallery: [IMAGES.calmSeaBox, IMAGES.alZahraBag],
        description:
            "A refreshing attar that captures the serene beauty of the ocean breeze and the purity of nature. Inspired by the peaceful harmony of the coast, it evokes a sense of calm, clarity, and refined freshness.",
        notes: {
            top: ["Ocean Breeze", "Bergamot"],
            heart: ["Marine Accord", "White Flowers"],
            base: ["White Musk", "Driftwood", "Salt Air"],
        },
    },
];

export const BAKHOOR_PRODUCT = {
    id: "bakhoor",
    name: "Bakhoor Combodi Oud",
    tag: "Premium Bakhoor Chips",
    price: 500,
    sizes: [
        { label: "40 g", inr: 500, aed: 50 },
        { label: "100 g", inr: 1200, aed: 120 },
        { label: "500 g", inr: 6250, aed: 625 },
        { label: "1 kg", inr: 11000, aed: 1100 },
    ],
    series: "The Bakhoor Collection",
    caption: "For the Majlis",
    badge: "Smoke Ritual",
    image: `${ASSET2}/cmmh8pfb_8de02372-ee09-424c-ad9a-f08c32980c47.JPG`,
    description:
        "Hand-pressed agarwood chips soaked in fragrant oils. Rest a piece on hot charcoal or an electric burner and let the slow smoke scent your home, your clothes and your gatherings.",
    notes: {
        top: ["Smoked Oud Chips", "Frankincense"],
        heart: ["Amber Resin", "Dried Rose"],
        base: ["Sandalwood", "Warm Musk"],
    },
};

export const AMBER_RIYADH = {
    id: "amber-riyadh",
    name: "Amber Riyadh",
    tag: "Premium Bakhoor",
    price: 550,
    sizes: [
        { label: "40 g", inr: 550, aed: 50 },
        { label: "100 g", inr: 1320, aed: 120 },
        { label: "500 g", inr: 6875, aed: 625 },
        { label: "1 kg", inr: 12100, aed: 1100 },
    ],
    series: "The Bakhoor Collection",
    badge: "Smoke Ritual",
    image: `${ASSET2}/z1ye3hv4_ChatGPT%20Image%20Aug%2022%2C%202026%20at%2002_35_08%20AM.png`,
    description:
        "Golden amber glowing over smoked oud and desert resins. Amber Riyadh turns any room into a warm Arabian evening — generous, golden, and long lasting.",
    notes: {
        top: ["Smoked Oud", "Saffron"],
        heart: ["Golden Amber", "Labdanum"],
        base: ["Sandalwood", "Warm Resins"],
    },
};

export const CONTACT = {
    whatsapp: "916291341914",
    whatsappDisplay: "+91 62913 41914",
    instagram: "al_zahraperfumery",
    website: "www.alzahraperfumery.com",
    owner: "Saad Arifin",
};
